// PD-01: Captain removed — copilot reply feature disabled.
// Stub refs keep the ReplyBox template from crashing.
import { ref } from 'vue';

export function useCopilotReply() {
  const copilotReply = ref('');
  const isFetchingReply = ref(false);
  const isActive = ref(false);
  const isButtonDisabled = ref(false);
  const showEditor = ref(false);
  const isGenerating = ref(false);
  const generatedContent = ref('');
  const editorTransitionKey = ref(0);

  const reset = () => {};
  const execute = () => {};
  const accept = () => '';
  const toggleEditor = () => {};
  const setContentReady = () => {};
  const sendFollowUp = () => {};

  return {
    copilotReply,
    isFetchingReply,
    isActive,
    isButtonDisabled,
    showEditor,
    isGenerating,
    generatedContent,
    editorTransitionKey,
    reset,
    execute,
    accept,
    toggleEditor,
    setContentReady,
    sendFollowUp,
  };
}
